import { useMutation } from '@tanstack/react-query';
import { useNavigate } from 'react-router-dom';
import * as Sentry from '@sentry/react';
import { RoutesList } from '@animal-nuisance/routes/Routes';
import { useAnimalNuisanceStore } from '@animal-nuisance/hooks/useAnimalNuisanceStore';

const submitData = async (payload: any) => {
  try {
    //placeholder until API is ready
    const urlPath = '/report/v1/animal-nuisance';
    const response = await fetch(
      `${import.meta.env.VITE_APIM_BASE_URL}${urlPath}`,
      {
        method: 'POST',
        body: JSON.stringify(payload),
        headers: {
          'Ocp-Apim-Subscription-Key': `${import.meta.env.VITE_APIM_API_KEY as string}`,
          'content-type': 'application/json',
        },
      },
    );
    const submitResponse = await response.json();
    if (!submitResponse || !submitResponse.case_reference) {
      throw new Error('Failed to submit report');
    }
    return submitResponse;
  } catch (error) {
    throw new Error((error as Error).message);
  }
};

export const useHandleSubmit = () => {
  const navigate = useNavigate();
  const { update } = useAnimalNuisanceStore();

  return useMutation({
    mutationFn: submitData,
    onSuccess: (data) => {
      if ((data && data.case_reference) || data.slaText) {
        update('caseReferenceId', data.case_reference);
        update('slaText', data.slaText);
      }
    },
    onError: (error) => {
      Sentry.captureException(error);
      navigate(RoutesList.INTERNAL_SERVER_ERROR);
    },
  });
};
